// src/components/Methodologie.js
import React, { useState }  from 'react'
import './Vision.css'
import flechetteBas from "../../../assets/images/courbe.png"

const Vision = () => {
  return (
    <div className="vision-container">
      <h2 className="vision-title">
        <span className="corner-vision top-left" />
        <span className="corner-vision top-right" />
        Notre vision
        <span className="corner-vision bottom-left" />
        <span className="corner-vision bottom-right" />
      </h2>
      <p className="vision-subtitle">
        Stimuler la croissance - <br />
        par l'innovation, et la transformation digitale
      </p>

      <div className="purple-card">
        <div className="card-textvision">
            <h3>Engagé dans une démarche d’innovation et d’adaptabilité, notre cabinet accompagne les PME et les startups dans leur transformation digitale et leur stratégie de gestion des ressources humaines. Nous proposons des solutions personnalisées pour renforcer leur agilité, accélérer leur digitalisation et optimiser le développement des talents, afin de bâtir une croissance durable et compétitive.
            </h3>
              <img src={flechetteBas} alt="Flechette décorative" className="image-dessous-h3" />
        </div>
        <div className="card-image" />
        </div>

    </div>
  )
}

export default Vision
